var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_108",
  "data-name": "Grupo 108",
  transform: "translate(-1.25 -1.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_40",
  "data-name": "Caminho 40",
  d: "M14.738,8.32a.562.562,0,0,1-.558-.558V6.273c0-2.344-.662-3.907-3.907-3.907S6.366,3.929,6.366,6.273V7.762a.558.558,0,0,1-1.116,0V6.273c0-2.158.521-5.023,5.023-5.023S15.3,4.115,15.3,6.273V7.762A.562.562,0,0,1,14.738,8.32Z",
  transform: "translate(-1.023)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_41",
  "data-name": "Caminho 41",
  d: "M11.169,17.587a2.419,2.419,0,1,1,2.419-2.419A2.423,2.423,0,0,1,11.169,17.587Zm0-3.721a1.3,1.3,0,1,0,1.3,1.3A1.309,1.309,0,0,0,11.169,13.866Z",
  transform: "translate(-1.919 -2.942)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_42",
  "data-name": "Caminho 42",
  d: "M12.971,19.3H5.529c-3.282,0-4.279-1-4.279-4.279V13.529c0-3.282,1-4.279,4.279-4.279h7.442c3.282,0,4.279,1,4.279,4.279v1.488C17.25,18.3,16.253,19.3,12.971,19.3Zm-7.442-8.93c-2.664,0-3.163.506-3.163,3.163v1.488c0,2.657.5,3.163,3.163,3.163h7.442c2.664,0,3.163-.506,3.163-3.163V13.529c0-2.657-.5-3.163-3.163-3.163Z",
  transform: "translate(0 -2.047)",
  fill: "#db56e0"
}))));
export default __webpack_public_path__ + "static/media/lock.9fc59a45.svg";
export { SvgComponent as ReactComponent };